import React from "react";
import "./AboutUsContent.css";
function AboutUsContent() {
  return (
    <React.Fragment>
      <div className="AboutUsWrapper">
        <div className="AboutUsWrapperHeading">We Simplify Car Ownership</div>
        <div className="AboutUsWrapperContentFirst">
          Over 7 years, DriveU has revolutionized the way consumers hire drivers
          for their private cars, and how businesses maintain a strong, reliable
          supply chain of professional drivers to transport vehicles. We have
          acquired over 700,000+ customers, 150+ businesses, that are served by
          100,000+ background verified, uniformed professional drivers, and have
          completed 5M+ Million trips.
        </div>
        <div className="AboutUsWrapperImageDiv">
          <img
            src="https://ik.imagekit.io/driveu/Web/group_photo_yZeAXneGM.png"
            alt="DriveU Team"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
        <div className="AboutUsWrapperContentSecond">
          In 2021, we launched India’s first Car Ownership Super App that allows
          users to book any service around car ownership such as general
          maintenance, roadside assistance, car cleaning, and much much more!
          What’s the big deal? Many services are infrequent and there’s no real
          use for a “cashback” on something you book once a year. Well, now car
          owners can gain reward coins that can be immediately redeemed for
          exclusive partner offers, discounts, or products!
        </div>
        <div className="CommercialAds">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/OH3743algOA?rel=0&controls=0"
            title="DriveU Commercial Ads"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="responsive-iframe"
          ></iframe>
        </div>
      </div>
    </React.Fragment>
  );
}

export default AboutUsContent;
